module.exports = "/_next/static/images/TwilioSegment@2x-77fb8d9983417940fb0b3f92e5047716.webp";